// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import type { AssignedCustomProperty } from '@evolvemep/api-ts';

import {
  CustomPropertiesList,
  type CustomPropertiesListProps,
} from 'components/Mantine/CustomProperties/CustomPropertiesList';
import { EditCustomPropertiesModal } from 'components/Mantine/CustomProperties/EditCustomPropertiesModal';
import { DetailSection } from 'components/Mantine/DetailPage/DetailSection';

export const CustomPropertiesDetailSection = <T extends { customProperties: AssignedCustomProperty[] }>(
  props: CustomPropertiesListProps<T>,
) => (
  <DetailSection
    title={`${props.customPropertyTypeName} Custom Properties`}
    rightSection={<EditCustomPropertiesModal customPropertyTypeName={props.customPropertyTypeName} />}
  >
    <CustomPropertiesList {...props} />
  </DetailSection>
);
